import { createFileRoute } from '@tanstack/react-router';
import { CasesPage } from '@/features/clinical/pages/cases-page';

export const Route = createFileRoute('/_app/clinical/')({ component: CasesPage });
